import {SET_SELECTED_STUDENT} from './types';


export const setSelectedStudent =
  (student: any) => async (dispatch: any) => {
    try {
      dispatch({type: SET_SELECTED_STUDENT, payload: student});
    } catch (error) {
      console.log('SET_SELECTED_STUDENT error: ', error);
    }
  };
